//FIXME: There's a better way to do this
//TODO: rewrite (this is broken with jquery upgrade)
if (
  $('.applyValidate input.required[id], .applyValidate select.required[id]')
    .length > 0
) {
  $('#notesBox').css('display', 'block');
}
